const services = [

  {
    icon: "💻",
    title: "Software Development",
    text: "Custom web and software applications for business requirements.",
    items: [
      "Custom Business Application",
      "Enterprise Software Solution",
      "Application Development",
      "API & Backend Development",
      "Software Maintenance & Support",
      "Application Enhanced & Upgrades"
    ]
  },

  {
    icon: "🌐",
    title: "Web Development",
    text: "Modern, responsive and professional websites and web applications.",
    items: [
      "Business Websites",
      "Corporate Websites",
      "E-Commerce",
      "React Applications",
      "Admin Dashboards"
    ]
  },

  {
    icon: "⚙️",
    title: "PLC Programming",
    text: "Industrial automation programming and machine control solutions.",
    items: [
      "Siemens S7",
      "Siemens TIA Portal",
      "Siemens PCS7",
      "Standard & Safety PLC Programming",
      "Mitsubishi GX Works"
    ]
  },

  {
    icon: "🖥️",
    title: "SCADA & HMI",
    text: "Industrial monitoring, visualization and control solutions.",
    items: [
      "WinCC Basic/Advanced",
      "SCADA Development",
      "HMI Screen Development",
      "Alarms Management",
      "Trends",
      "PLC Communication"
    ]
  },

  {
    icon: "🔧",
    title: "Commissioning & Support",
    text: "Complete project commissioning and technical support.",
    items: [
      "Onsite & Remote Commissioning",
      "Onsite PLC logic modification",
      "Onsite  SCADA/HMI Modification",
      "Remote & Onsite Troubleshooting",
      "Technical Support"
    ]
  },

  {
    icon: "📊",
    title: "Consultancy",
    text: "Technical consulting for software and industrial automation projects.",
    items: [
      "Project Planning",
      "Automation Consulting",
      "Software Consulting",
      "System Upgrades",
      "Technical Guidance"
    ]
  },
   {
    icon: "🛡️",
    title: "OT Security Services",
    text: "complete solutions for OT Security as per IEC-62443 Standard",
    items: [
      "OT Security Assessment",
      "OT Security Hardening",
      "OT Security AMC",
      "Complete Secure Automation projects ",
    
    ]
  }

];

function Services() {

  return (

    <section id="services" className="section services">

      <div className="section-title">

        <p>WHAT WE DO</p>

        <h2>Our Services</h2>

      </div>

      <div className="service-grid">

        {services.map((service, index) => (

          <div className="service-card" key={index}>

            <div className="service-icon">
              {service.icon}
            </div>

            <h3>{service.title}</h3>

            <p>{service.text}</p>

            <ul>

              {service.items.map((item, i) => (
                <li key={i}>✓ {item}</li>
              ))}

            </ul>

          </div>

        ))}

      </div>

    </section>

  );
}

export default Services;